// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2G7zj","list":"styles_list__3p-4L"};